import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useCurrentShopAdmin } from "@/api/shops/use-shop-admin";
import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import { useOpenReturnWidget } from "@/pages/(app)/embed/use-open-return-widget";
import useTranslation from "@babackapp/translations/use-translation";
import { SidebarMenuButton, useSidebar } from "@babackapp/ui/components/sidebar";
import { SparklesIcon } from "lucide-react";

/**
 * Opens the V3 return portal (apps/return-widget-embed) as an overlay inside the
 * dashboard. Always available to the Baback team; merchants only see it once a
 * super admin turns on the shop's `admin.returnWidget.demo` flag.
 */
export default function DemoReturnWidgetButton() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const { data: admin } = useCurrentShopAdmin();
  const isSuperAdmin = useViewerIsSuperAdmin();
  const { state } = useSidebar();
  const openReturnWidget = useOpenReturnWidget(shop.shopifyUrl, shop.providerId, {
    forceNewWidget: true,
  });

  if (!isSuperAdmin && !admin?.returnWidget?.demo) return null;

  const className =
    "text-indigo-600 dark:text-indigo-300 hover:bg-indigo-500/10 hover:text-indigo-700 dark:hover:text-indigo-200";

  if (state === "collapsed") {
    return (
      <SidebarMenuButton
        size="sm"
        onClick={openReturnWidget}
        tooltip={t("sidebar.demoNewPortal")}
        className={className}
      >
        <SparklesIcon />
      </SidebarMenuButton>
    );
  }

  return (
    <SidebarMenuButton
      size="sm"
      onClick={openReturnWidget}
      className={`${className} justify-center gap-1.5`}
    >
      <SparklesIcon />
      {t("sidebar.demoNewPortal")}
    </SidebarMenuButton>
  );
}
